export default __webpack_public_path__ + "static/media/폰트사이즈-아이콘.f8f8f329.svg";